import { IonButtons, IonContent, IonHeader,IonIcon, IonMenuButton, IonPage, IonTitle, IonToolbar,IonTabs,IonTabBar,IonTabButton } from '@ionic/react';
import Arbol  from '../components/Arbol';
import { person, call,settings   } from 'ionicons/icons';

const Calculo = () => {

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle style={{fontSize:"18"}}>IC crónica con FE &lt;50%</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen className="IonPadding" >
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="small">Tratamiento de la IC crónica con FE &lt;50%</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <Arbol/>
                
            </IonContent>

        </IonPage>
    );
};

export default Calculo;
